export class FamilyHistoryModel {
  patientcode = '' ;
  relativedegree = '' ;
  //cancerName ='';
  relation = '' ;
  cancerid = '' ;
  age = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;
   cancername = '';
   id =0;
}
